import React from 'react';
import AssignmentActionFlowModal, {
	ActionTarget,
	ActionTargetOption
} from '../AssignmentActionFlowModal';

export type UnassignTarget = ActionTarget;

const UNASSIGN_OPTIONS: ActionTargetOption[] = [
	{
		value: 'all',
		title: 'All previously selected users',
		description:
			'Unassign this training to all users included in the last assignment.'
	},
	{
		value: 'specific',
		title: 'Specific users',
		description:
			'Unassign this training from selected users only, based on property, role, group or individual selection.'
	}
];

interface UnassignScheduledModalProps {
	visible: boolean;
	onCancel: () => void;
	onContinue: (target: UnassignTarget) => void;
}

const UnassignScheduledModal: React.FC<UnassignScheduledModalProps> = ({
	visible,
	onCancel,
	onContinue
}) => (
	<AssignmentActionFlowModal
		visible={visible}
		onCancel={onCancel}
		onContinue={onContinue}
		select={{
			title: 'Unassign training',
			description: 'Choose who you want to unassign this training from.',
			options: UNASSIGN_OPTIONS,
			actionLabel: 'Continue'
		}}
		confirmAll={{
			title: 'Unassign training?',
			intro: 'Unassigning this training will:',
			items: [
				'Delete progress for 5 learners',
				'Affect 20 learners total'
			],
			actionLabel: 'Unassign'
		}}
		specific={{
			title: 'Unassign specific users',
			description: 'Unassign users from this training',
			actionLabel: 'Unassign'
		}}
		confirmSpecific={{
			title: 'Confirm unassign',
			intro: 'Unassigning this training will:',
			items: [
				'Affect 2 properties',
				'Delete progress for 5 learners',
				'Affect 430 learners total'
			],
			actionLabel: 'Unassign'
		}}
	/>
);

export default UnassignScheduledModal;
